import type { Category } from '@/types';

export const categories: Category[] = [
  {
    id: 'film',
    name: '影视',
    slug: 'film',
    desc: '院线新片、热播剧集、幕后花絮与深度影评，第一时间掌握大银幕小屏幕的光影动态。',
    icon: 'ri-film-line',
    accent: 'primary',
    filters: [
      { key: 'type', label: '类型', options: ['全部', '电影', '电视剧', '综艺', '纪录片'] },
      { key: 'region', label: '地区', options: ['全部', '内地', '欧美', '日韩', '港台'] },
      { key: 'year', label: '年份', options: ['全部', '2026', '2025', '2024'] },
    ],
  },
  {
    id: 'music',
    name: '音乐',
    slug: 'music',
    desc: '新歌首发、专辑解读、演唱会资讯与音乐人专访，追踪华语与全球乐坛的每一次脉动。',
    icon: 'ri-music-2-line',
    accent: 'accent',
    filters: [
      { key: 'style', label: '风格', options: ['全部', '流行', '摇滚', '说唱', '民谣', '电子'] },
      { key: 'time', label: '发行时间', options: ['全部', '本月', '本季', '今年'] },
    ],
  },
  {
    id: 'star',
    name: '明星',
    slug: 'star',
    desc: '明星动态、八卦热搜、红毯造型与幕后故事，近距离感受聚光灯内外的人物魅力。',
    icon: 'ri-star-smile-line',
    accent: 'secondary',
    filters: [
      { key: 'gender', label: '性别', options: ['全部', '男艺人', '女艺人'] },
      { key: 'status', label: '活跃状态', options: ['全部', '当红', '回归中', '新晋'] },
    ],
  },
  {
    id: 'trend',
    name: '潮流',
    slug: 'trend',
    desc: '穿搭灵感、美妆趋势、联名尖货与生活方式，捕捉年轻人正在热爱的每一股潮流风向。',
    icon: 'ri-fire-line',
    accent: 'primary',
    filters: [
      { key: 'field', label: '领域', options: ['全部', '穿搭', '美妆', '数码', '生活方式'] },
      { key: 'season', label: '季节', options: ['全部', '春夏', '秋冬'] },
    ],
  },
];